export class Spinner {

	public readonly element: HTMLDivElement = document.createElement("div");
	private counter: number = 0;
	protected handles: boolean[] = [];
	private hideHandle: number = 0;
	private showHandle: number = 0;

	constructor(elements: number = 4) {
		this.element.className = "spinner";
		const container = document.createElement("div");
		container.classList.add("spinner_container");
		for (let i = 0; i < elements; i++) {
			const el = document.createElement("div");
			el.className = "spinner_el";
			container.appendChild(el);
		}
		this.element.appendChild(container);
	}

	public push(): void {
		this.counter++;
		clearTimeout(this.hideHandle);
		this.element.classList.add("-rendered");
		this.showHandle = setTimeout(() => this.element.classList.add("-active"), 10);
	}

	public pop(): void {
		if (this.counter <= 0) {
			throw new Error("Counter already at 0");
		}
		this.counter --;
		if (this.counter === 0) {
			this.hideElement();
		}
	}

	private hideElement(): void {
		this.element.classList.remove("-active");
		clearTimeout(this.hideHandle);
		clearTimeout(this.showHandle);
		this.hideHandle = setTimeout(() => {
			this.element.classList.remove("-rendered");
		}, 500);
	}

	public async watch<T>(promise: Promise<T>): Promise<T> {
		this.push();
		try {
			return await promise;
		} finally {
			this.pop();
		}
	}
}

